export const SET_SELECTED_ROOMS = 'SET_SELECTED_ROOMS';
export const SET_SELECTED_EXTRAS = 'SET_SELECTED_EXTRAS';
export const SET_SELECTED_ACTIVITIES = 'SET_SELECTED_ACTIVITIES';
export const SET_TRIP_ID = 'SET_TRIP_ID';
export const SET_NOTES = 'SET_NOTES';
export const SET_DEALER_CLIENT = 'SET_DEALER_CLIENT';
export const SET_REFUNDABLE = 'SET_REFUNDABLE';
export const SET_GUEST_INFO = 'SET_GUEST_INFO';